export default [{
  'picUrl': '/static/images/banner1.png'
}]



// WEBPACK FOOTER //
// ./src/assets/config/home/banner.js